import { isNil } from 'lodash/fp'
import { Mark } from 'components/Mark'
import { statusMarkings } from 'features/home/consts'

import { UNUSED_STATUS_CODE } from '../consts'

interface StatusIndicatorProps {
  status: number
}

function StatusIndicator({ status: statusIndex }: StatusIndicatorProps) {
  if (statusIndex === UNUSED_STATUS_CODE || isNil(statusIndex)) {
    // make sure to not show status other than online/offline
    return null
  }
  return <Mark marking={statusMarkings[statusIndex]} />
}

export default StatusIndicator
